require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-cotham-rd-kew.json") })
        }
      }, "path---project-cotham-rd-kew");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-cotham-rd-kew!./.cache/json/project-cotham-rd-kew.json
// module id = 565
// module chunks = 231608221292675